export default __webpack_public_path__ + "static/ico_cookie-39606de670a07b7c7238df640d583e2a.svg";